import {Component, Inject, OnInit} from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';

interface ResourceResult {
  name: string;
  type: string;
  group: string;
  version: string;
  success: boolean;
  errorMessage?: string;
}

@Component({
    selector: 'app-create-generic-resources-result',
    templateUrl: './create-generic-resources-result.component.html',
    styleUrls: ['./create-generic-resources-result.component.scss'],
    standalone: false
})
export class CreateGenericResourcesResultComponent implements OnInit {
    title: string;
    public successful: ResourceResult[] = [];
    public failed: ResourceResult[] = [];
    expandedErrors: boolean[] = [];

    constructor(public dialogRef: DialogRef) {
        if (this.dialogRef.data) {
            this.successful = this.dialogRef.data.successful || [];
            this.failed = this.dialogRef.data.failed || [];
            this.expandedErrors = new Array(this.failed.length).fill(false);
        }
    }

    ngOnInit(): void {
        this.title = "Resource Creation Report";
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    toggleErrorDetails(index: number) {
        this.expandedErrors[index] = !this.expandedErrors[index];
    }
}